module.exports = __webpack_public_path__ + "assets/78cf82998f983dfe5d9901fd5b36c2cb.mp3";